import { Pipe, PipeTransform } from '@angular/core';
import { buildEditIntegrationNewLink } from '../../helpers/route-params.helper';

@Pipe({ name: 'editIntegrationLink' })
export class EditIntegrationLinkPipe implements PipeTransform {
  transform(
    baseWord: unknown,
    datasourceId: unknown,
    integrationName: unknown,
    sourceId: unknown,
  ): unknown[] | null {
    return buildEditIntegrationNewLink(baseWord, datasourceId, integrationName, sourceId);
  }
}
